module.exports = __webpack_public_path__ + "img/icon_2.601c5587.png";